import { render } from "./HomeSevenPage.vue?vue&type=template&id=3dd4ca4f&ts=true"
import script from "./HomeSevenPage.vue?vue&type=script&lang=ts"
export * from "./HomeSevenPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__